import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api";
import Button from "../../components/Button";
import Header from "../../components/Header";
import InputField from "../../components/InputField";
import { LoaderContext } from "../../context/LoaderContext";
import { isPaidUser } from "../../helper/functions";
import { useToken } from "../../helper/hooks";
import {
  StyledFormContainer,
  StyledGeneratorContainer,
  StyledMainContainer,
} from "../../styles/global";
import { StyledGenerateUrlHeader } from "./styled";

interface Props {}

const GenerateShortUrl: React.FC<Props> = () => {
  const { showLoader } = useContext(LoaderContext);
  const { setToken, user } = useToken();
  const navigate = useNavigate();
  const [state, setState] = useState({
    url: "",
    shortId: "",
  });
  const generateUrl = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    showLoader({
      show: true,
    });
    await api
      .GenerateShortUrl({
        url: state.url,
        shortId: state.shortId,
      })
      .then((res) => {
        if (res.status === 201) {
          showLoader({
            show: false,
          });
          toast.success(res.data.message);
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        showLoader({
          show: false,
        });
        if (err.response?.data?.data?.token) {
          setToken(err.response?.data?.data?.token);
        }
        toast.error(err.response?.data?.message || "Something went wrong");
      });
  };
  return (
    <>
      <Header title="WhatQR" />

      <StyledMainContainer>
        <StyledGenerateUrlHeader>
          <h1>Generate new short URL</h1>
        </StyledGenerateUrlHeader>

        <StyledGeneratorContainer padding="24px">
          <StyledFormContainer>
            <InputField
              type="text"
              value={state.url}
              onChange={(e) => {
                setState({
                  ...state,
                  url: e.target.value,
                });
              }}
              label="Destination URL"
              name="desturl"
              placeholder="Enter a URL where you want to redirect..."
            />

            {/* {isPaidUser(user).isPaid ? ( */}
            <InputField
              type="text"
              disabled={isPaidUser(user).isPaid ? false : true}
              value={state.shortId}
              onChange={(e) => {
                setState({
                  ...state,
                  shortId: e.target.value,
                });
              }}
              adornment={<span>{process.env.REACT_APP_HOST_DOMAIN}</span>}
              label="Short URL"
              name="shorturl"
              placeholder="custom-slug"
              helperText={
                isPaidUser(user).isPaid
                  ? ""
                  : "Upgrade to paid plan to use this feature."
              }
            />
            {/* ) : null} */}

            <Button
              style={{ width: "100%" }}
              label={"Generate"}
              onClick={(e) => {
                generateUrl(e);
              }}
            />
          </StyledFormContainer>
        </StyledGeneratorContainer>
      </StyledMainContainer>
    </>
  );
};

export default GenerateShortUrl;
